@if (!invisible() && portraits$()) {
	@let styleClass = 'dc-avatar flex border border-solid border-primary-400 ' + (blockEffects() ? '' : 'transform transition duration-5000 ease-in-out hover:scale-150') + ' ' + avatarStyleClass();
	<p-avatarGroup [styleClass]="containerStyleClass()">
		@for (userPortrait of portraits$(); track userPortrait.id) {
			@if (userPortrait.file) {
				<p-avatar
					[matTooltip]="userPortrait?.displayName"
					[class]="`hover:z-[20] ${avatarClass()}`"
					[styleClass]="styleClass + ' bg-transparent'"
					[image]="userPortrait.file.webEncode"
					[size]="size()"
					shape="circle"
				/>
			} @else if (userPortrait?.initials) {
				<p-avatar
					[matTooltip]="userPortrait?.displayName"
					[class]="`hover:z-[20] ${avatarClass()}`"
					[styleClass]="styleClass + ' bg-white'"
					[size]="size()"
					shape="circle"
					[label]="userPortrait?.initials"
				/>
			} @else if (userPortrait.notificationSrc) {
				<p-avatar
					[matTooltip]="userPortrait?.displayName"
					[class]="`hover:z-[20] ${avatarClass()}`"
					[styleClass]="styleClass + ' bg-white'"
					[size]="size()"
					shape="circle"
					[icon]="userPortrait.notificationSrc"
				/>
			}
		}
	</p-avatarGroup>
}
